import { ReactNode, FC } from 'react'
import { Container } from './styles'
import { HiCheck } from 'react-icons/hi'

interface StepBulletProps {
  children?: ReactNode;
  isComplete?: boolean;
  id?: string;
}

const StepBullet: FC<StepBulletProps> = ({ children, isComplete, id }) => {
  // isComplete hardcoded to false to disable green <HiCheck/> 
  const FEATURE_FLAG_FE_VALIDATIONS: boolean = false
  isComplete = FEATURE_FLAG_FE_VALIDATIONS

  return (
    <Container id={id} isComplete={!!isComplete}>
      {!isComplete ? children : <HiCheck color='#FFF' />}
    </Container>
  )
}

export default StepBullet